import React, { useRef, useEffect } from 'react'
import { ReactSVG } from "react-svg";
import hotshot4 from '../../../assets/images/Hotshot4.png'
import digitalDisplay3 from '../../../assets/images/misc/digitalDisplay3.svg';
import './FinalCTA.css'

const FinalCTA = () => {
  const svgRef = useRef(null);
  const svgRef2 = useRef(null);
  const titleRef = useRef(null);
  const titleLetters = "Your Choices Matter.".split("");
  const contentRef = useRef(null);
  const imageRef = useRef(null);  // Removed animatedRef as we don't need it anymore

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            if (entry.target === titleRef.current) {
              entry.target.classList.add('active');
              const letters = entry.target.querySelectorAll('.title-letter');
              letters.forEach((letter, index) => {
                setTimeout(() => {
                  letter.classList.add('animate');
                }, index * 1); 
              });
            } else {
              entry.target.classList.add('animation');
            }
            // Unobserve after animation is triggered
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );
    
    const contentObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
            contentObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );
    
    if (titleRef.current) observer.observe(titleRef.current);
    if (svgRef.current) observer.observe(svgRef.current);
    if (svgRef2.current) observer.observe(svgRef2.current);
    if (contentRef.current) contentObserver.observe(contentRef.current);
    if (imageRef.current) contentObserver.observe(imageRef.current);

    return () => {
      observer.disconnect();
      contentObserver.disconnect();
    };
  }, []);

  return (
    <section className="choices-section">
      <div className="container">
        <div className="background-gradient-right"></div>
        <div className="background-gradient-left"></div>
        
        <div className="title-container fns-title-choices" ref={titleRef}>
          <div className="digital-lines-choices"></div>
          {titleLetters.map((letter, index) => (
            <span 
              key={index} 
              className="title-letter"
              style={{ animationDelay: `${index * 0.05}s` }} // Reduced to 50ms delay
            >
              {letter === ' ' ? '\u00A0' : letter}
            </span>
          ))}
          <span className="cursor">|</span>
        </div>

        <div className="content-grid">
          <div className="content-text" ref={contentRef}>
            <p>
              The decks that the drones are equipped with are for more than battle. These tools can be used in a diverse range of situations for utility, decision making, and to provide reliable social behaviours for each Fox to draw from.
            </p>
            <p>
              Depending on how you run your deck, you may find opportunities to exercise your cunning, see different details about where you are, or make enemies out of the other inhabitants ghosting about in the scrapping grounds.
            </p>
            <p>
              Just be mindful of how long you spend scavenging in the city.  The longer you take, the more unwanted attention you’ll gain. 
              You’ll need to rely on your wits to decide whether you are ready to tackle the bosses, or if you're willing to go for broke and risk wiping out that extra bit of scrap.
            </p>
          </div>
          <div className="content-image" ref={imageRef}>
            <img src={hotshot4} alt="Fox and Shadow gameplay" className="final-centered-image" />
            <div className='digitalDisplay3 left' ref={svgRef}>
              <ReactSVG src={digitalDisplay3}/>
            </div>
            <div className='digitalDisplay3 right' ref={svgRef2}>
              <ReactSVG src={digitalDisplay3}/>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default FinalCTA